import * as React from 'react';

import {
    Container,
    Col,
    Popover,
    PopoverBody,
    PopoverHeader,
    Row,
} from 'reactstrap';

import { 
    RoleResponse,
    PortalTextSettings,
} from '../../../Models/Api/strongbox.financialportal';

import { UserRoleAdministrator, UserRoleDefaultUser } from '../../../Utils/Constants';

import CloseIcon from '@mui/icons-material/Close';

export type PermissionsPopoverTarget = {
    target: string;
    role: RoleResponse;
}

type Props = {
    target: PermissionsPopoverTarget;
    onToggle: (on: boolean) => void;
    settingsText?: PortalTextSettings;
}

export const PermissionsDetailPopover: React.FC<Props> = (props): React.ReactElement => {
    const {
        onToggle,
        target,
        settingsText,
    } = props;

    const targetDescription = React.useMemo(() => {
        let descriptions: string[] = [];

        switch (target.role.id) {
            case UserRoleAdministrator:
                descriptions = settingsText?.addUserPermissionsAdministrator || [];
                break;
            case UserRoleDefaultUser:
                descriptions = settingsText?.addUserPermissionsDefaultUser || [];
                break;
        }

        return (
            <ul>
                {descriptions.map((d, i) => {   
                    return (
                        <li key={`target-role-description-${i}`}>
                            {d}
                        </li>
                    )

                })}
            </ul>
        )
        // These are the dependencies I actually want
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [target]);

    return (
        <div className={`control-region control-region-lender`}>
            <Popover
                placement={'right'}
                isOpen={true}
                className={'naics-popover'}
                target={target.target}
                key={'permissionDetailsPopover'}
                toggle={() => onToggle && onToggle(false)}
                trigger={'legacy'}
            >
                <PopoverHeader>
                    <div className={'portal-header-region spaced-row'}>
                        <span>
                            {settingsText?.addUserPermissions || ''}
                        </span>
                        <CloseIcon
                            color={'primary'}
                            className={'basic-list-icon actionable-icon'}
                            onClick={() => onToggle && onToggle(false)}
                            id={'closepopover'}
                        />
                    </div>
                </PopoverHeader>
                <PopoverBody className={'naics-body'}>
                    <Container fluid
                        className={'naics-primary-description'}
                        key={'naics-descriptions-container'}
                    >
                        <Row>
                            <Col>
                                {
                                    targetDescription
                                }
                            </Col>
                        </Row>
                    </Container>
                </PopoverBody>
            </Popover>
        </div>
    );
}
